import {
  EXTERNCALL_REST,
  DEALERS_BY_CAR,
  CLEAR_HOUR,
  UPDATE_USER,
  DEALERS_INFO,
  IS_REQUESTING,
  REQUESTING_END,
  CAR_INFO,
  TIME_INFO,
  APPOINTMENT
} from "../actions/types";

const initialState = {
  intel: {
    dealers: null,
    dealersByCars: null,
    dealerDays: [],
    dealerHours: [],
    user: null,
    dealerInfo: {},
    carInfo: null,
    timeInfo: {},
    appointment: {},
  },
  requesting: false
};

function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return str;
  }
  return JSON.parse(str);
}

export default (state = initialState, action) => {
  var newState;
  switch (action.type) {
    case IS_REQUESTING:
      return {
        ...state,
        requesting: true
      };
    case REQUESTING_END:
      return {
        ...state,
        requesting: false
      };

    case EXTERNCALL_REST:
    console.log("extRest")
      newState = { ...state };
      newState.intel[action.name] = IsJsonString(action.data);
      return newState;

    case DEALERS_BY_CAR:
      newState = { ...state };
      newState.intel["dealersByCars"] = action.data;
      return newState;

    case CLEAR_HOUR:
      newState = { ...state };
      newState.intel["dealerHours"] = [];
      return newState;

    case UPDATE_USER:
      newState = { ...state };
      newState.intel["user"] = action.data;
      return newState;

    case DEALERS_INFO:
      newState = { ...state };
      newState.intel["dealerInfo"] = action.data;
      return newState;

    case CAR_INFO:
      newState = { ...state };
      newState.intel["carInfo"] = action.data;
      return newState;

    case TIME_INFO:
      newState = { ...state };
      newState.intel["timeInfo"] = action.data;
      return newState;

    case APPOINTMENT:
      newState = { ...state };
      newState.intel["appointment"] = action.data;
      return newState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/restIntel.js